import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * <compound-copy>: one server-rendered <details data-variant-id> per compound (blocks/compound-copy.liquid).
 * Opens the panel of the variant the picker selects and closes the others — nothing is refetched;
 * Horizon's product page morphs only <variant-picker>, so these panels stay as rendered.
 * The block lives in the Fitment band beneath the two columns (outside `#ProductInformation-<id>`, the
 * details column), so it listens on the section wrapper `.product-information`, where the picker's
 * ProductSelectEvent bubbles to (fallback: the details column, for a block placed there).
 *
 * @extends {Component}
 */
class CompoundCopy extends Component {
  #target = null;

  connectedCallback() {
    super.connectedCallback();
    this.#target = this.closest('.product-information') ?? this.closest('[id*="ProductInformation-"]');
    this.#target?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#target?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /** @param {import('@shopify/events').ProductSelectEvent} event */
  #handleProductSelect = (event) => {
    event.promise
      .then(({ variant, detail }) => {
        const raw = variant?.id ?? detail?.resource?.id;
        if (raw == null) return;
        const id = String(raw).split('/').pop();
        for (const panel of this.querySelectorAll('details[data-variant-id]')) {
          panel.open = panel.dataset.variantId === id;
        }
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[compound-copy] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('compound-copy')) {
  customElements.define('compound-copy', CompoundCopy);
}
